export default "__VITE_ASSET__817b62d5__"